import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export default function SearchFilterByCategories({ filterByCategory }) {
    const currentLanguage = useSelector(({ language }) => language.currentLanguage);
    const navbarCategory = useSelector(({ navigation }) => navigation.navbarCategory);
    const wording = useSelector(({ language }) => language.wording);
    const searchData = useSelector(({ search }) => search.searchData);
    const [categoryFilter, setCategoryFilter] = useState([]);

    useEffect(() => {
        if (searchData) {
            const category = navbarCategory.filter(nav => searchData.some(data => data.categories.includes(nav.categoryNameEn)));
            setCategoryFilter(category);
        }
    }, [searchData])

    return (
        <div className='widget categories'>
            <h3 className='widget-title heading relative heading-small uppercase bottom-line style-2 left-align'>
                {wording.SearchPage.categories.title}
            </h3>
            <ul className='list-dividers'>
                {
                    categoryFilter.length != 0 &&
                        [{ categoryNameEn: "ALL", categoryNameTh: "ทั้งหมด" }].concat(categoryFilter)
                            .filter(nav => nav.categoryNameEn != "HOME")
                            .map((nav, index) => (
                                <li key={index}>
                                    <a href="#" onClick={(e) => filterByCategory(e, nav.categoryNameEn)}>
                                        {currentLanguage === 'TH'
                                            ? nav.categoryNameTh
                                            : nav.categoryNameEn}
                                    </a>
                                </li>
                            ))
                }
            </ul>
        </div>
    );
}
